module.exports = __webpack_public_path__ + "static/assets/fe83ec2d52dfba5b85252c9611f1aa4c.png";